import {SpinnerState} from './spinner.state';
import * as spinners from './spinner.actions';

export const initialState: SpinnerState =  {item:{visible:false}};

export function spinnerReducer(state = initialState, action: spinners.Actions): SpinnerState {

	switch (action.type) {
        case spinners.SPINNER_VISIBLE:

			return {
               item : action.payload


			};
        case spinners.SPINNER_HIDDEN:

            return {
                item : action.payload

        };

        default:
			return state;
	}
}
